<ng-http-loader *ngIf="deviceInfoService.showHttpLoader"
    [backdrop]="true"
    [backgroundColor]="'#02a783'"
    [spinner]="'sk-three-bounce'"
    [opacity]="1"
    [backdropBackgroundColor]="'transparent'"
></ng-http-loader>
<!--app header starts here-->
<lib-baker-header [isSideNavigation]="isSideNav"
  (toggleNavigation)="toggleSidenav()" (toggleMobileMenu)="toggleMobileMenu()" [isMenuOpen]="isMenuOpen" [headerLogoSrc] = "'./assets/bhlogo.svg'">
  <div appname class="mat-toolbar-row__divider">
    <a class="mat-toolbar__app-name-text">ProductionLink Edge</a>
  </div>
    <div profile-menu class="header-side">
      <ple-header-notification-menu></ple-header-notification-menu>
      <ple-header-profile-menu  [profileDetails]="profileDetails"></ple-header-profile-menu>
    </div>
</lib-baker-header>
<!--app header ends here-->
<lib-bh-mobile-menu  *ngIf="isMenuOpen && profileDetails" [mobileMenuData]="mobileMenuData" (navigationSelected)="navigationSelected()"></lib-bh-mobile-menu>
<!--side nav starts here-->
<mat-sidenav-container class="sidenav-container" hasBackdrop="false" autosize>
    <mat-sidenav #appDrawer class="sidenav" mode="side" [fixedInViewport]="false" opened="true"
    [attr.role]="'navigation'">
    <mat-nav-list>
      <ple-side-nav [permissions]="permissions" *ngFor="let item of navItems" [appDrawer]="getSavedStateForMatDrawer()" [item]="item" [itemList]="navItems" (navParentMenuClicked)="navParentMenuClicked($event)"></ple-side-nav>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav #assetTreeNav mode="side" class="asset-side-nav" *ngIf="isAssetTreeOpen" opened="isAssetTreeOpen" >
    <asset-tree></asset-tree>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="page-wrapper">
    <div class="pages-container">
      <router-outlet></router-outlet>
    </div>
    <ple-footer>
      <div footer-links>
        <a class="footer-link" href="https://www.bakerhughes.com/privacy" target="_blank">Privacy Notice</a>
        <a *ngIf="verisonText" style="margin-left: 50px;"><strong>{{verisonText}}</strong></a>
      </div>
    </ple-footer>
  </div>
  </mat-sidenav-content>
</mat-sidenav-container>
